import React, { useState } from "react";
import { CheckoutType, PopupCheckoutType } from "types";
import { ContentLayout } from "../../Layout/ContentLayout";
import { NewStepFourButtonCodeSection } from "./Steps/NewStepFourButtonCodeSection";
import { StepFourButtonCodeSection } from "./Steps/StepFourButtonCodeSection";
import { StepOneCommonSiteCode } from "./Steps/StepOneCommonSiteCode";
import { StepThreeChooseDesign } from "./Steps/StepThreeChooseDesign";
import { StepTwoCheckoutTypeSelector } from "./Steps/StepTwoCheckoutType";
import { hasX2CheckoutWithFullProbability } from "@/models/Seller";

export const ButtonCode = () => {
    const [checkoutType, setCheckoutType] = useState<CheckoutType>(CheckoutType.POPUP);
    const [popupType, setPopupType] = useState<PopupCheckoutType>(PopupCheckoutType.DEFAULT);

    const handleCheckoutTypeChange = (type: CheckoutType) => {
        if (type !== CheckoutType.POPUP) {
            setPopupType(PopupCheckoutType.DEFAULT);
        }

        setCheckoutType(type);
    };

    const handleChangePopupType = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPopupType(e.target.value as PopupCheckoutType);
    };

    return (
        <ContentLayout isWide>
            <h2 className="mt-4">Buttons</h2>
            <div className="flex flex-col divide-y divide-gray">
                <StepOneCommonSiteCode />
                {/* This should be omitted for X2 checkout */}
                {!hasX2CheckoutWithFullProbability() && (
                    <StepTwoCheckoutTypeSelector checkoutType={checkoutType} onChange={handleCheckoutTypeChange} />
                )}
                <StepThreeChooseDesign
                    popupType={popupType}
                    checkoutType={checkoutType}
                    onChangePopup={handleChangePopupType}
                />
                {hasX2CheckoutWithFullProbability() ? (
                    <NewStepFourButtonCodeSection popupType={popupType} />
                ) : (
                    <StepFourButtonCodeSection checkoutType={checkoutType} popupType={popupType} />
                )}
            </div>
        </ContentLayout>
    );
};
